<template>
  <div>
    <div class="row m2 card-body">
      <div class="col-lg-12">
        <div class="col-lg-12 col-xs-12 mb-2">
          <default-colors v-model="tag.color" />
        </div>
        <div class="col-lg-12 d-flex justify-content-center col-xl-12">
          <chrome v-model="tag.color" @change-color="onChange"></chrome>
        </div>
        <div class="col-lg-12 d-flex justify-content-center mt-2">
          <input
            class="no_border form-control"
            type="text"
            placeholder="Nome da etiqueta"
            v-model="tag.name"
          />
        </div>
        <div class="col-lg-12 d-flex jusitify-content-center mt-2">
          <button class="btn btn-primary full" @click="sendTag">
            <b>Salvar</b><i class="ml-2 fas fa-check-circle"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Photoshop, Chrome } from "vue-color";
import DefaultColors from "./DefaultColors.vue";
import Axios from "axios";
export default {
  mounted() {
    this.getIdAccount();
  },
  components: { Chrome, DefaultColors },
  data: () => ({
    tag: {
      name: "",
      color: "#FFF",
      account_id: "",
    },
    tags: "",
  }),
  watch: {
    "tag.color": function () {
      eventBus.$emit("deselectColor", this.tag.color);
    },
  },
  methods: {
    onChange(val) {
      this.tag.color = val;
    },
    getIdAccount() {
      axios.get("/recruiters/tags").then((response) => {
        this.tag.account_id = response.data.account_id_tag;
      });
    },
    sendTag() {
      if (this.tag.name.trim().length === 0) {
        this.$toast.error("Por favor preencha o nome da tag.");
        return;
      }

      axios
        .post("/recruiters/tags/create", {
          tag: {
            name: this.tag.name.trim().toLowerCase(),
            color: this.tag.color.hex || this.tag.color,
            account_id: this.tag.account_id,
          },
        })
        .then((response) => {
          this.tags = response.data.tags;
          this.$emit("close");
        });
      this.tag = {
        name: "",
        color: "#FFF",
      };
    },
  },
};
</script>